export default function viewerRoles ({ team = [], user = {} }) {
    const { roles = [] } = team.filter(t => {
        return t.user_reference === user.user_reference;
    })[0] || { roles: []};
    
    let viewer_roles = roles;
    if (user.is_admin) { viewer_roles = ['read', 'write', 'approve', 'admin'] };
    
    return viewer_roles;
}